import { Component, OnInit, Input, OnDestroy, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { ReportsHelpbuttonService } from '../../../services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-helpbutton-reports-time-card',
  templateUrl: './helpbutton-reports-time-card.component.html',
  styleUrls: ['./helpbutton-reports-time-card.component.scss']
})
export class HelpbuttonReportsTimeCardComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() data;
  count;
  showCounter: boolean;
  refreshAssistancesListSubscription: Subscription;

  constructor(private reportsService: ReportsHelpbuttonService,
              private spinnerService: SpinnerService) { }

  ngOnInit() {
    // this.refreshAssistancesListSubscription = this.reportsService.refreshAssistancesListListen().subscribe(
    //   (res) => {
    //     this.data = res['data']['assistanceAverageTimeMillis'];
    //   },
    //   (error) => {
    //   }
    // );
  }

  ngAfterContentChecked() {
    this.spinnerService.show('reports-time-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('reports-time-spinner');
      this.showCounter = true;
      this.count = this.data;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
    }
  }

  ngOnDestroy() {
    if (this.refreshAssistancesListSubscription) { this.refreshAssistancesListSubscription.unsubscribe(); }
  }

}
